export type UseCase = { title: string; description: string };

export const useCases: UseCase[] = [
  {
    title: "Startups",
    description:
      "Deploy your first application with a flexible VPS and move toward cloud or dedicated infrastructure as usage grows.",
  },
  {
    title: "Developers",
    description:
      "Spin up isolated environments for projects and experiments, with full control over configuration.",
  },
  {
    title: "Digital Agencies",
    description:
      "Manage client websites, applications and email requirements through scalable infrastructure options.",
  },
  {
    title: "Ecommerce",
    description:
      "Support online stores with infrastructure selected around performance, stability and growth.",
  },
  {
    title: "Growing Teams",
    description:
      "Move internal tools and communication onto infrastructure that can expand alongside headcount.",
  },
  {
    title: "Enterprise Workloads",
    description:
      "Run larger, more complex systems on dedicated or cloud infrastructure configured to your requirements.",
  },
];
